import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Grid, Icon, Dropdown, Header, Checkbox } from 'semantic-ui-react'
import * as actionCreators from '../../actions'
import { confirmAlert } from 'react-confirm-alert';
import {  togglePGAForm } from '../../actions'
// import { updatePgaCorrectionSelected } from '../../actions';
import { pgaLabels, pgaErrors } from '../../text'
import { pgaTypes, pgaFlags } from './constantsPGA'
import {  deleteUnusedPGAS } from "../../api/htsRequests"; 
import PGAItem from './PGAItem'
import { getJobWheels } from "../../../util/index";
import { DropDown } from '../../formComponents/dropDown'
import { displayMasterItem, displayDropDownItem } from '../util'
import {
  deletePgaOnProgramChange,
  setdocPgaCorrectionOption,
} from "../../api/setFormData";
import _ from 'lodash'
import { createDisclaimPGAForm, getTargetPGAForm } from '../../api/getEntrySummaryData';
import { propsAreEqual_NoRerenderNeeded } from '../../reducer/util';
import { universalFormValidate } from '../util/index';
import { disclaimReasonsPGAReasons } from './disclaimCodes';

export class PGAItems extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeAccordianIndex: '',
      pgaCorrectionSpinner: false
    }
  }

  shouldComponentUpdate(nextProps, nextState){
    if(window.slowstate)return true;

    return ((this.state.forceRerender||0) + 15000 > Date.now()) || !propsAreEqual_NoRerenderNeeded(this.state,nextState) || !propsAreEqual_NoRerenderNeeded(this.props,nextProps);

  }
  getOpenFunction(formType,pgaGuid, index,isManuallyAddedPga) {
    const {
      merchandiseId,
      lineItemIndex,
      invoiceItemIndex,
      updateMerchLineItemPgaObject,
      pgaFlagInfos,
    } = this.props
    if((this.props.pgaFlagInfos||[]).find(aaa=>aaa.pgaGuid == pgaGuid)?.isOnlyForDisclaim)return;
    if((window.lastClickJAQ||0)+100 > Date.now())return;
    let collapsing = !this.props.expandAll && index === this.state.activeAccordianIndex;
    togglePGAForm(pgaFlagInfos, merchandiseId,pgaGuid, formType, lineItemIndex,  {isManuallyAddedPga:isManuallyAddedPga}, collapsing)
    this.setActiveAccordianIndex(index, formType)

  }

  setActiveAccordianIndex = (index) => {
    if (index === this.state.activeAccordianIndex) {
      this.setState({
        activeAccordianIndex: ''
      })
    } else {
      this.setState({
        activeAccordianIndex: index
        
      })
    }
  }

  componentWillMount(){
    const { lineItemIndex, invoiceItemIndex, updateMerchLineItemFeild} = this.props
  }

  render() {
    const {
      hsDataDtl,
      pgaFlagInfos,
      pgaRuling,
      newValue,
      lineItemIndex,
      invoiceItemIndex,
      merchandiseId,
      updateMerchLineItemPgaObject,
      updateMerchLineItemFeild,
      formDisabled,
      expandAll,
      fieldValidation,
      currentJobData,
      updateEntryTypeField,
      allVoluntaryPGAs,
      createNewPgaSelection,
    } = this.props
    // gets the target flag based on the PGA we are looking at
    let flagIsCompletedByGuid = (pgaGuid, formType) =>{
      let trimGuid = (guid)=>{
        if(!guid || guid.indexOf("FAKEGUID_")>=0)return ""
        return guid;
      }

      let myFlag = pgaFlagInfos.find(
        a=>trimGuid(a.pgaGuid) == trimGuid(pgaGuid) &&
          a.formType == formType
      );
      if(myFlag?.isOnlyForDisclaim)return true;

      return myFlag?.pgaFlagStatus == '1';
    }
    let shipmentId = currentJobData.shipmentId;
    

    let docPgaCorrectionOptionToggle = {};
    for(let existingCheckbox of (this.props.entryTypeInfo?.linePgaUpdateInfo?.pgaUpdateInfos||[])){//reload old Pga correction checkboxes
      if(existingCheckbox.merchandiseId == merchandiseId){
        docPgaCorrectionOptionToggle[existingCheckbox?.formType+"_xxxxx_"+((existingCheckbox?.pgaGuid||"").indexOf("FAKEGUID_")>=0?"":(existingCheckbox?.pgaGuid||""))] = existingCheckbox.status == "checked";
      }
    }
    
    //
    const { activeAccordianIndex } = this.state
    
    let normalizedCountryOfOrigin = this.props.countryOfOrigin;
    if(["XA","XB","XC","XM","XN","XO","XP","XQ","XS","XT","XV","XW","XY"].includes(normalizedCountryOfOrigin)){
      normalizedCountryOfOrigin = "CA"; //Canadian provinces are just CA for PGAs
    }
    let jobwheels = getJobWheels(currentJobData.countryCode, currentJobData);
    let docPgaCorrectionOption = jobwheels?.SHIPMENT_US_PGA_PROCESS?.value?.state=="STATE_PGA_UPDATE_IN_PROCESS";


    const formTypeToShortName = (formType)=>{
      return pgaLabels[formType]?pgaLabels[formType]:
                formType.replace("_"," ")
    }
    const tarriffPgaDetailsToReact = (pgaFlagInfosToCopy, requiredPGAsToCopy, copyVoluntaryPGAs)=>{
      let requiredPGAs = JSON.parse(JSON.stringify(requiredPGAsToCopy||[]))
      let pgaFlagInfos = JSON.parse(JSON.stringify(pgaFlagInfosToCopy||[]));
      let voluntaryPGAs = JSON.parse(JSON.stringify(copyVoluntaryPGAs||[]));
      let pgaListXX = [];
      let missingPgas = [];
      let totalCountOfEachProgram = {};
      for(let onePga of pgaFlagInfos){
        let myProgram = onePga?.pgaType?.substring(0,3);
        if(!myProgram)continue;
        totalCountOfEachProgram[myProgram]=totalCountOfEachProgram[myProgram]?totalCountOfEachProgram[myProgram]+1:1;
      }
      let pgaTypes = {};
      for(let onePga of pgaFlagInfos.sort((a,b)=>a?.createdTimeInMs - b?.createdTimeInMs)){
        let myProgram = onePga?.pgaType?.substring(0,3);
        if(!myProgram)continue;
        if(totalCountOfEachProgram[myProgram] > 1){
          pgaTypes[myProgram]=pgaTypes[myProgram]?pgaTypes[myProgram]+1:1
          onePga.computedEDIIndex = pgaTypes[myProgram]
        }
        
      }
      for(let oneFlag of pgaFlagInfos){
        oneFlag.pgaGuid = oneFlag.pgaGuid || "FAKEGUID_"+oneFlag.pgaType+merchandiseId
      }
      for (let onerequiredPGA of requiredPGAs || []) {
        onerequiredPGA.voluntary_Baz = false;
        for (let oneFlag of pgaFlagInfos) {
          if ((onerequiredPGA.programDetails || []).map(a => a.formType || a.pgaType).includes(oneFlag.pgaType)) {//find the associated db value
            onerequiredPGA.databaseAssociatedPga = oneFlag; //set it to the current required pga
            break;
          }
        }
        pgaListXX.push(onerequiredPGA)
      }
      for(let oneFlag of pgaFlagInfos){//now add all voluntary PGAs
        let hasThisone = false;
        for(let potentialVoluntaryToCopy of voluntaryPGAs){
          let potentialVoluntary = JSON.parse(JSON.stringify(potentialVoluntaryToCopy));
          let voluntaryMatchesFlag = ((potentialVoluntary.programDetails||[]).map(a=>a.formType)).includes(oneFlag.pgaType || oneFlag.formType);
          voluntaryMatchesFlag |= oneFlag.pgaType === "DISCLAIM_PGA";
          voluntaryMatchesFlag |= oneFlag.formType === "DISCLAIM_PGA";
          if(voluntaryMatchesFlag){
            
            potentialVoluntary.databaseAssociatedPga = oneFlag;
            potentialVoluntary.voluntary_Baz = true;
            
            if(!potentialVoluntary?.databaseAssociatedPga?.pgaGuid || !pgaListXX.map(a=>a?.databaseAssociatedPga?.pgaGuid).includes(potentialVoluntary?.databaseAssociatedPga?.pgaGuid)){
              pgaListXX.push(potentialVoluntary)
            }
            hasThisone = true;
            break;
          }
        }
        if(!hasThisone){
          missingPgas.push(oneFlag)
        }
      }


      const hasDisclaimPga = !!pgaFlagInfos.find(a=>a.formType=="DISCLAIM_PGA"||a.pgaType=="DISCLAIM_PGA");

      let pscUpdateInProgress = jobwheels?.SHIPMENT_US_PGA_PROCESS?.value?.state == 'STATE_PGA_UPDATE_IN_PROCESS';
      return <>
      
      
      <input type="hidden" id={"RELOAD_THIS_PGA_"+merchandiseId} onClick={()=>{
            this.setState({forceRerender:Math.random()});
          }}/>
      {
       pgaListXX.map((pgaItem, index) => {
        let pgaUpdateButtonId  =merchandiseId+"pgaIndex"+index+"selectForUpdate";

        let pgaDropdownOption = [];
        let pgaDisclaimOption = [];
        let seemCodes = [];
        let programNameTranslated = (pgaItem) => {
          if(pgaItem?.databaseAssociatedPga?.pgaType == "TSCA" || _.get(pgaItem,"programDetails[0].formType")=="TSCA")return "TSCA";
          if(pgaItem?.databaseAssociatedPga?.pgaType == "LACEY" || _.get(pgaItem,"programDetails[0].formType")=="LACEY")return "LACEY";
          return pgaItem.programName;
        }
        const existingPgaOfThisType =    (pgaFlagInfos||[]).find(oneFlag => oneFlag.formType.startsWith(programNameTranslated(pgaItem)));
        const existingPgaOfThisTypeList= (pgaFlagInfos||[]).filter(oneFlag => oneFlag.formType.startsWith(programNameTranslated(pgaItem)));
        const existingPgaNotOfThisTypeList= (pgaFlagInfos||[]).filter(oneFlag => !oneFlag.formType.startsWith(programNameTranslated(pgaItem)));
        const isOnlyForDisclaimThisPGA = pgaItem?.databaseAssociatedPga?.isOnlyForDisclaim;
        const disclaimedCodeThisPGA = pgaItem?.databaseAssociatedPga?.disclaimCode;
     
       


        let disclaimCheckBoxes = null;
        
         for (let _item of pgaItem.programDetails.sort((aaa, bbb) => {
           if (aaa.formType == "APH_APQ") return -1;//APQ gets priority!
           if (bbb.formType == "APH_APQ") return 1;
           return 0;


         })) {
       

          for (let oneCode of (_item.disclaimCodes || [])) {
            const onelabel = pgaItem.programName + "" + oneCode;
            if(seemCodes.includes(onelabel))continue;
            pgaDisclaimOption.push({
              description: `Disclaim [${oneCode}] [${_item.formType}]`,
              data: _item,
              disclaimCode: oneCode,
              programName: pgaItem.programName,
            });
            seemCodes.push(onelabel);
         }
         if(pgaDisclaimOption.length==0 && pgaItem.programName == "FDA" && pgaItem.tariffCode != "FD2"){
          pgaDisclaimOption.push({
            description: `Disclaim [FDA] `,
            data: {
              formType: "FDA_FOO",//Doesn't matter which formtype is disclaimed
              programCode: "FDA",
            },
            disclaimCode: "A",
            programName: "FDA",
          });
         }



           const onlyForAphAndFDA = ["FDA","APH"].includes(programNameTranslated(pgaItem))//delete this var when this feature is enabled for all pgas
          disclaimCheckBoxes = onlyForAphAndFDA && !pgaItem.voluntary_Baz && (!!pgaDisclaimOption?.length) && <>
            <div style={{ width: '250px', float: 'right', marginRight:"30px", textAlign: 'right' }} onClick={(event) => {
              event.preventDefault();

            }}>

              <div style={{}}>
                {programNameTranslated(pgaItem)} DISCLAIM
              </div>
              {pgaDisclaimOption.map((oneDisclaimOption, iii) => {
                const thisBoxIsChecked = !!((pgaItem?.databaseAssociatedPga?.disclaimFlag  == "Y" || isOnlyForDisclaimThisPGA) && disclaimedCodeThisPGA == oneDisclaimOption.disclaimCode);
                return <React.Fragment key={oneDisclaimOption.description+"xxux"+iii}>
                  <div key={oneDisclaimOption.description+"xxx"+iii} style={{ display: 'inline-block', marginLeft: '10px' }}>
                    <Checkbox
                      key={oneDisclaimOption.description}
                      className='fdaDisclaimCheckbox'
                      style={{ padding: '0px' }}
                      label={oneDisclaimOption.disclaimCode}
                      checked={thisBoxIsChecked}
                      width={3}
                      onClick={(event) => {
                        if (existingPgaOfThisType && !isOnlyForDisclaimThisPGA) {
                          if (!window.confirm(`Disclaim this PGA? Existing ${programNameTranslated(pgaItem)} data will be deleted`)){
                            window.lastClickJAQ = Date.now();
                            return;
                          }
                        }
                        window.lastClickJAQ = Date.now();
                        if(thisBoxIsChecked){
                          deleteUnusedPGAS(existingPgaNotOfThisTypeList, existingPgaOfThisTypeList, merchandiseId, shipmentId, lineItemIndex, invoiceItemIndex, updateMerchLineItemPgaObject, updateMerchLineItemFeild, false)

                          return;
                        }
                        this.setState({ disclaimingInProcess: true });

                        //                      
                        createDisclaimPGAForm(
                          {
                            formType: oneDisclaimOption.data.formType,
                            disclaimCode: oneDisclaimOption.disclaimCode,
                            govtAgencyCode: oneDisclaimOption.programName,//FDA
                            govtAgencyProgramCode: oneDisclaimOption.data.programCode,//FOO
                          },
                          shipmentId,
                          merchandiseId,
                        ).then(creationComplete => {
                          const createdPga = _.get(creationComplete, "data.eventMessage.disclaimedPGAForms[0]");
                          if (createdPga) {

                            const newlistOfFlags = (pgaFlagInfos || []).filter(oneFlag => !oneFlag.formType.startsWith(programNameTranslated(pgaItem))).concat({
                              disclaimCode: oneDisclaimOption.disclaimCode,
                              pgaType: createdPga.pgaType || createdPga.formType,
                              ...createdPga
                            });
                            const deletePromise = deleteUnusedPGAS(newlistOfFlags, existingPgaOfThisTypeList, merchandiseId, shipmentId, lineItemIndex, invoiceItemIndex, updateMerchLineItemPgaObject, updateMerchLineItemFeild, false)

                            if (deletePromise) {
                              deletePromise.then(responseDoneDelete => {
                                this.setState({ disclaimingInProcess: false });

                              });
                            } else {
                              setTimeout(() => {
                                this.setState({ disclaimingInProcess: false });
                              }, 1000);
                            }
                          }
                        });
                      }}
                      disabled={Boolean(formDisabled) || this.state.disclaimingInProcess}
                    />
                  </div>
                </React.Fragment>
              })}
            </div>
          </>;
        }

        let errorsforpga = (fieldValidation.validObjects_bl[`Merchandiseqwqr${'pgaerrors'}${index}${merchandiseId}`]||[])
         pgaItem.programDetails.map((_item, _index)=>{
            pgaDropdownOption.push({
              key: _item.programCode,
              description: _item.programDefinition,
              text: "Change Program",
              value: _item.formType,
              disabled: (_item.active == 2)
            })
          })       
          let march19th2024 = 1710806400000;//AMS_OR2 not before this date!
          if([this.props?.entryTypeInfo?.releaseDate?.epochs||0, this.props?.entryTypeInfo?.entryDate?.epochs||0, Date.now()].find(aaa=>aaa>10000) <  march19th2024 ){
            let amsor2Option = pgaDropdownOption.find(aaa=>aaa.value=="AMS_OR2")
            if(amsor2Option)amsor2Option.disabled=true;
          }

          const onlyOnePGA = (pgaDropdownOption||[]).length==1;
          let dropdownId = `${lineItemIndex}-${index}-pgaMeta${pgaItem.programName}${merchandiseId}${shipmentId}`;
          if(!pgaItem.voluntary_Baz && !pgaItem.databaseAssociatedPga){
            if(this.state[`openingxPgas${pgaItem.programName}${index}`]){
              return<div className={`tarriffPgaDetails`} key={`ytarriffPgaDetails-${index}-${pgaItem.voluntary_Baz}-${pgaItem?.databaseAssociatedPga?.pgaGuid}`}>
                   Loading {this.state[`openingxPgas${pgaItem.programName}${index}`]} PGA<br/>
              </div>
            }
            return (
              <div className={`tarriffPgaDetails`} key={`ytarriffPgaDetails-${index}-${pgaItem.voluntary_Baz}-${pgaItem?.databaseAssociatedPga?.pgaGuid}`}>
              {pgaDropdownOption.find(a=>!a.disabled)?<> 
                {`The HTS Code flags for ${pgaItem.programName}, please select applicable agency program to proceed.`} <br />
                <div style={{display:'flex'}}>
                <DropDown
                  disabled={this.state.disclaimingInProcess || Boolean(formDisabled) || (pgaItem.programName === "FDA" && hasDisclaimPga)}
                  id={`${lineItemIndex}-${index}-pgaMeta${pgaItem.programName}${merchandiseId}`}
                  label='AGENCY PROGRAM'
                  placeholder='Choose PGA'
                  selection
                  className='field-bg dropdown100'
                  columnClassName={'tallfloatSelect'}
                  isLabel={false}
                  icon={`angle down`}
                  errors={(pgaItem.programName === "FDA" && hasDisclaimPga || isOnlyForDisclaimThisPGA) ? [] : errorsforpga}
                  data={_.uniq(pgaDropdownOption)}
                  shipmentId={shipmentId}
                  width={11}
                  text={this.state["PGACREATION"+index] || 'Choose PGA'}
                  onChange={value => {
                    this.setState({creatingPga:"Creating a "+value+"..."});
                    this.setState({disclaimingInProcess: `Working...`});
                    setTimeout(()=>{
                      this.setState({disclaimingInProcess:false});
                    },3500);

                    createNewPgaSelection(value,false,null,{parentThis_pq:this,parentThisIndex_pq:index});
                  }}
                  newValue={newValue}
                />
                {hasDisclaimPga &&
                  pgaItem.programName === "FDA" && <>Old disclaim, obsolete</>
                }
                {disclaimCheckBoxes}
                  </div>
                </>:
                <>
                {(!!pgaDropdownOption.length && pgaDropdownOption[0].value)?
                  `${pgaDropdownOption[0].value} is currently not enabled. Please contact support!`
                  :`No PGA for this field. Please contact support!`
                }
                </>
              }
            </div>
            );
          }
          
          let twoOfThisFlag=(pgaFlagInfos||[])//only allow change if there's less than 2 of the same program type
          .map(dddd=>(dddd.formType||dddd.pgaType))
          .filter(a=>pgaItem?.databaseAssociatedPga?.pgaType?.indexOf(a)==0).length>1;
          let guidtemp = pgaItem?.databaseAssociatedPga?.pgaGuid||"";
          let pgaCorrectionYesNo = docPgaCorrectionOptionToggle[pgaItem?.databaseAssociatedPga?.pgaType+"_xxxxx_"+(guidtemp.indexOf("FAKEGUID_")>=0?"":guidtemp)];
          if(pgaItem?.databaseAssociatedPga?.pgaType == "DISCLAIM_PGA" && pgaFlagInfos && (pgaFlagInfos.filter(a=>a.formType=="DISCLAIM_PGA"||a.pgaType=="DISCLAIM_PGA"||a.formType.indexOf("FDA")==0).length < 2)){
            return <React.Fragment key={`xxxhxxx_${merchandiseId}__${index}_${pgaItem?.tariffCode}_${pgaItem?.programName} ${pgaItem?.databaseAssociatedPga?.pgaGuid}`}></React.Fragment>
          }
          return <React.Fragment key={`xxxhxxx_${merchandiseId}__${index}_${pgaItem?.tariffCode}_${pgaItem?.programName} ${pgaItem?.databaseAssociatedPga?.pgaGuid}`}>
            <React.Fragment
            key={index+" "+pgaItem?.databaseAssociatedPga?.pgaType+"+"+pgaItem.voluntary_Baz+" "+pgaItem?.databaseAssociatedPga?.pgaGuid}>
            <div
              className={`accordian-section tab-content pga-container 
                ${(formDisabled && !docPgaCorrectionOption)?' disabled ':' '} 
                ${docPgaCorrectionOption?' correctingPga ':' '}
                ${pgaItem?.databaseAssociatedPga?.pgaType}
                ${isOnlyForDisclaimThisPGA?' isOnlyForDisclaim ':' '}
                `}
                style={{whiteSpace:'nowrap',paddingBottom:'0px'}}
          >
          {pgaItem.voluntary_Baz && <Icon
            name="trash alternate outline"
            onClick={() => {
              if(activeAccordianIndex === index){
                this.getOpenFunction(pgaItem?.databaseAssociatedPga?.pgaType,pgaItem?.databaseAssociatedPga?.pgaGuid, index,pgaItem.voluntary_Baz)
              }
              
              let newPGAList = JSON.parse(JSON.stringify(pgaFlagInfos))
              newPGAList = newPGAList.filter(a=>a.pgaGuid != pgaItem?.databaseAssociatedPga?.pgaGuid)
              console.log('newPGAList: ', pgaFlagInfos, newPGAList,[pgaItem.databaseAssociatedPga]);
              if(!window.confirm(`Delete ${formTypeToShortName(pgaItem?.databaseAssociatedPga?.pgaType)}?`)){return;}
              this.setState({[`deletingAfter${index-1}`]:pgaItem?.databaseAssociatedPga?.pgaType})
              setTimeout(()=>{
                this.setState({[`deletingAfter${index-1}`]:null})
              },1200);
              deleteUnusedPGAS(newPGAList,  [pgaItem.databaseAssociatedPga]  ,  merchandiseId, shipmentId, lineItemIndex, invoiceItemIndex, updateMerchLineItemPgaObject,updateMerchLineItemFeild, false) 
            }}
            disabled={Boolean(formDisabled) && !(pscUpdateInProgress && pgaCorrectionYesNo)}
          />}
          <div
            style={{display:'inline-block',width:pgaItem.voluntary_Baz?'calc(100% - 21px)':'100%'}}
            className='title'
            onClick={() => {
              if(isOnlyForDisclaimThisPGA)return;
              if(expandAll || formDisabled)return ;
              let pgaGuid = pgaItem?.databaseAssociatedPga?.pgaGuid;
              this.getOpenFunction(pgaItem?.databaseAssociatedPga?.pgaType,pgaGuid, index,pgaItem.voluntary_Baz)
              
             
              if (document.getElementsByClassName("formContentarea_bc")?.length && document.getElementById(`pgaanchorll${pgaGuid}`)) {

                document.getElementsByClassName("formContentarea_bc")[0].scrollTop +=
                  document.getElementById(`pgaanchorll${pgaGuid}`).getBoundingClientRect().top - 400;
              }
              
            }}
          >
            {!isOnlyForDisclaimThisPGA && <Icon
              name={
                (activeAccordianIndex === index || expandAll)
                  ? 'angle down'
                  : 'angle right'
              }
            />}
            <a id={"pgaanchorll"+pgaItem?.databaseAssociatedPga?.pgaGuid} style={{
                position: 'relative',
                top: '-60px',
            }}></a>
            <span className='pga-status'>
              {flagIsCompletedByGuid(pgaItem?.databaseAssociatedPga?.pgaGuid, pgaItem?.databaseAssociatedPga?.formType) ? (
                <Icon name='check circle' className='done-pga' />
              ) : (<Icon name='warning sign' className='undone-pga' />)}
            </span>
            {/*pga name is here!!!!!v*/}
                  <div style={{ maxWidth: '40%', marginRight:'10px', display:'inline-block' }}>
                    {`${isOnlyForDisclaimThisPGA?pgaItem.programName:formTypeToShortName(pgaItem?.databaseAssociatedPga?.pgaType || "")} 
            
            ${(pgaItem?.databaseAssociatedPga?.computedEDIIndex && twoOfThisFlag) ?
                        (pgaItem.databaseAssociatedPga.computedEDIIndex + "").padStart(3, "0")
                        : ""}
                
            - ${flagIsCompletedByGuid(pgaItem?.databaseAssociatedPga?.pgaGuid, pgaItem?.databaseAssociatedPga?.formType) ?
                        (isOnlyForDisclaimThisPGA?`Disclaimed: ${disclaimReasonsPGAReasons[disclaimedCodeThisPGA] || `Unknown Disclaim ${disclaimedCodeThisPGA}`}`:
                        pgaErrors.completePGAMessage) :
                        isOnlyForDisclaimThisPGA ? "PGA is disclaimed. " :
                          pgaItem.voluntary_Baz ? pgaErrors.manualPGAMessage :
                            pgaErrors.incompletePGAMessage

                      }`}
                  </div>
                
                {disclaimCheckBoxes}
            {/*pga name is here!!!!!^*/}
            
                  {docPgaCorrectionOption ?
                    <button className="btn editPgaButton" 
                    disabled={this.state.pgaCorrectionSpinner}
                    style={{margin:'2px'}}
                      onClick={(event)=>{
                        setTimeout(()=>{
                          document.getElementById("RERENDER__BUTTONS") &&document.getElementById("RERENDER__BUTTONS").click();
                        },50)
                        if(this.state.pgaCorrectionSpinner)return;

                        let oldState = !!pgaCorrectionYesNo;
                        event.stopPropagation()

                        let checkTheBox = () => {
                          this.setState({ pgaCorrectionSpinner: true });
                          setdocPgaCorrectionOption(pgaItem?.databaseAssociatedPga?.pgaGuid, merchandiseId, pgaItem?.databaseAssociatedPga?.pgaType, !oldState).then((response) => {

                            // if((activeAccordianIndex === index)  == !oldState){
                            //   this.getOpenFunction(pga.formType, index)
                            // }
                            let replacementStatusList = this.props.entryTypeInfo?.linePgaUpdateInfo?.pgaUpdateInfos || [];
                            replacementStatusList = replacementStatusList.filter(a => a.merchandiseId != merchandiseId 
                              || a.formType != pgaItem?.databaseAssociatedPga?.pgaType 
                              || a.pgaGuid != pgaItem?.databaseAssociatedPga?.pgaGuid)
                            replacementStatusList.push({
                              pgaGuid: pgaItem?.databaseAssociatedPga?.pgaGuid,
                              "merchandiseId": merchandiseId,
                              "formType": pgaItem?.databaseAssociatedPga?.pgaType,
                              "status": oldState ? "unchecked" : "checked"

                            })
                            updateEntryTypeField('linePgaUpdateInfo', { pgaUpdateInfos: replacementStatusList });
                            this.setState({ pgaCorrectionSpinner: false });
                          });
                        }
                        if (oldState) {
                          confirmAlert({
                            closeOnClickOutside: true,
                            title: <><Icon name='warning sign' size='small' color='yellow'/>PGA Changes will persist</>,
                            message: 'Unchecking \'Update PGA\' prevents the PGA from transmitting during a PGA Final Review. The changes you have made to the PGA are persisted',
                            buttons: [
                              {
                                label: "Okay",
                                onClick: () => checkTheBox()
                              }
                            ]
                          })
                        } else {
                          checkTheBox()
                        }



                        return false; 
                      }}
                    >
                    <Checkbox
                    className='field-bg'
                    style={{
                        "minHeight": "20px",
                        lineHeight: "12px",
                        fontSize: "10px",
                      }}
                      readonly={false}
                      id={pgaUpdateButtonId}
                      label={"Update PGA"}
                      checked={pgaCorrectionYesNo}
                    />
                    </button>
                    : <>
                      </>
                  }
                  {
                        (isOnlyForDisclaimThisPGA || pgaItem.programDetails.length > 1) && !pgaItem.voluntary_Baz &&
                        <div key={`tarriffPgaDetails-${index}+"xxxxxuytxx"+${merchandiseId}-${pgaItem?.databaseAssociatedPga?.pgaGuid}`} className={"tarriffPgaDetailsChange"}><DropDown
                          disabled={twoOfThisFlag || (Boolean(formDisabled) && !pgaCorrectionYesNo) || this.state[`openingxPgas${pgaItem.programName}${index}`]}
                               id={`${lineItemIndex}-${index}-pgaMeta`}
                          //label='CHANGE AGENCY PROGRAM'
                          //placeholder='Choose PGA'
                          selection
                          className='field-bg noBorder changeProgram'
                          icon={`angle down`}
                          isLabel={false}
                          text={twoOfThisFlag?`Multiple ${formTypeToShortName(pgaItem?.databaseAssociatedPga?.pgaType)}`:
                            isOnlyForDisclaimThisPGA?"Create Program":
                            "Change Program"}
                          data={pgaDropdownOption}
                          shipmentId={shipmentId}
                          handleFocus={()=>{
                            if(formDisabled)return;
                            if(activeAccordianIndex === index){
                              this.getOpenFunction(pgaItem?.databaseAssociatedPga?.pgaType,pgaItem?.databaseAssociatedPga?.pgaGuid, index, pgaItem.voluntary_Baz)
                            }
                          }}
                          onChange={value => {
                            if (value && (isOnlyForDisclaimThisPGA || pgaItem?.databaseAssociatedPga?.pgaType !== value)) {
                              
                              this.setState({[`openingxPgas${pgaItem.programName}${index}`]: value })
                              setTimeout(()=>{
                                this.setState({[`openingxPgas${pgaItem.programName}${index}`]:false})
                              },7500)
                              
                              getTargetPGAForm(pgaItem?.databaseAssociatedPga?.pgaType, pgaItem?.databaseAssociatedPga?.pgaGuid, merchandiseId, {}).then((myoldPga)=>{
                                let deleteResponse = deleteUnusedPGAS(
                                  pgaFlagInfos.filter(a => a.pgaGuid != pgaItem?.databaseAssociatedPga?.pgaGuid), [pgaItem?.databaseAssociatedPga], merchandiseId, shipmentId, lineItemIndex, invoiceItemIndex, updateMerchLineItemPgaObject, updateMerchLineItemFeild, false
                                );
                                if (deleteResponse) {
                                  deleteResponse.then(responseX => {
                                    setTimeout(() => {//we need the new redux state to add an additional pga, hence this code which waits for the delete and then calls the add from the ui
                                      window[merchandiseId + "addnewPgaInput"] = { pgaType: value, manuallyAddedPage: false, myoldxPga: myoldPga?.data?.eventMessage };
                                      document.getElementById(`${merchandiseId}addnewPgaInput`).click()
                                      setTimeout(() => {
                                        this.setState({ [`openingxPgas${pgaItem.programName}${index}`]: false })
                                      }, 1500);
                                    }, 500)
                                    if (pgaCorrectionYesNo) {
                                      setTimeout(() => {
                                        document.getElementById(pgaUpdateButtonId) && document.getElementById(pgaUpdateButtonId).click();
                                      }, 2500)
                                    }
                                  });
                                }
                              })
                                
                              // let eventMsg = {
                              //   formType: [pgaItem?.databaseAssociatedPga?.pgaType],
                              //   merchandiseId: merchandiseId,
                              //   shipmentId: shipmentId
                              // }
                              // window.deleting_GLOBALS_X = {...(window.deleting_GLOBALS_X||{}),[`${merchandiseId}${pgaItem?.databaseAssociatedPga?.pgaType}`]:Date.now()}
                              // this.setState({[`openingxPgas${pgaItem?.databaseAssociatedPga?.pgaGuid}`]:true})
                              // setTimeout(()=>{
                              //   deletePgaOnProgramChange(eventMsg).then((response)=>{
                              //     window.deleting_GLOBALS_X = {...(window.deleting_GLOBALS_X||{}),[`${merchandiseId}${pgaItem?.databaseAssociatedPga?.pgaType}`]:Date.now()}
                              //     setTimeout(()=>{
                              //       selectPGARedux(lineItemIndex, invoiceItemIndex,
                              //         merchandiseId,
                              //         value,
                              //         index, pgaDropdownOption);
                              //         this.setState({[`openingxPgas${pgaItem?.databaseAssociatedPga?.pgaGuid}`]:false})
                                      
                              //       console.log('getOpenFunctio4n: ');
                              //       this.getOpenFunction(value, "" /*create*/,index, pgaItem.voluntary_Baz)
                              //     },700)
                              //   })
                              // },400)
                            }
                          }}
                          newValue={newValue}
                        /></div>
                      } 
          </div>
          <input type="hidden" id={"RELOAD_THIS_PGA_"+pgaItem?.databaseAssociatedPga?.pgaGuid} onClick={()=>{
            togglePGAForm(null, merchandiseId,pgaItem?.databaseAssociatedPga?.pgaGuid, pgaItem?.databaseAssociatedPga?.pgaType, 0, 
              {},false)
          }}/>
          {
            (activeAccordianIndex === index || expandAll || Boolean(formDisabled))
            && !isOnlyForDisclaimThisPGA && <PGAItem
              lineItemIndex={lineItemIndex}
              invoiceItemIndex={invoiceItemIndex}
              countryOfOrigin={normalizedCountryOfOrigin}
              entryTypeInfo={this.props.entryTypeInfo}
              merchandiseId={merchandiseId}
              modeOfTransport={this.props.modeOfTransport}
              open={() => {
                this.getOpenFunction(pgaItem?.databaseAssociatedPga?.pgaType,pgaItem?.databaseAssociatedPga?.pgaGuid, index, pgaItem.voluntary_Baz)
              }}
              pgaIsCompletedByGuid={flagIsCompletedByGuid(pgaItem?.databaseAssociatedPga?.pgaGuid, pgaItem?.databaseAssociatedPga?.formType)}
              clearPGAFlag={()=>{
                
                setTimeout(() => {
                  universalFormValidate({ props: { justinvalidatePGA: true, pgaGuid: pgaItem?.databaseAssociatedPga?.pgaGuid, formType: pgaItem?.databaseAssociatedPga?.pgaType } }, merchandiseId, updateMerchLineItemPgaObject, merchandiseId,
                    pgaItem?.databaseAssociatedPga.pgaFlagName,
                    lineItemIndex, invoiceItemIndex)
                  this.setState({ forceRerender: Date.now() });
                }, 400)}}

              hsDataDtl_paramy={this.props.hsDataDtl_paramy}
              expandAll={expandAll || Boolean(formDisabled)}
              setActiveAccordianIndex={this.setActiveAccordianIndex}
              formDisabled={Boolean(formDisabled) && !pgaCorrectionYesNo}
              updateMerchLineItemPgaObject={updateMerchLineItemPgaObject}
              pgaProgram={pgaItem.pgaProgram}
              pgaSubProgram={pgaItem.pgaSubProgram}
              pgaType={pgaItem.pgaProgram}
              formType={pgaItem?.databaseAssociatedPga?.pgaType}
              pgaGuid={pgaItem?.databaseAssociatedPga?.pgaGuid}
              containerListAsArray={this.props.containerListAsArray}
              allVoluntaryPGAs={this.props.allVoluntaryPGAs}
              voluntary_Baz={pgaItem.voluntary_Baz}
            />
          }
              </div>

              {!!this.state[`deletingAfter${index}`] && <div>

                <Icon
                  className={' minispinner '}
                  name={'spinner'}
                  style={{ width: '20px', height: '20px' }}
                  inverted
                  disabled={true}
                  link
                  id='delete-text'
                />
                Deleting {formTypeToShortName(this.state[`deletingAfter${index}`])}
              </div>}
            </React.Fragment>
          </React.Fragment>
    })}
    {!!missingPgas?.length && <>MISSING PGAs: {JSON.stringify(missingPgas)}</>}
    </>
    }

   if(hsDataDtl?.pgaDataLoading)return <></>;
    return (
      <Grid padded columns='equal'>
      
      <br/>
         {tarriffPgaDetailsToReact(pgaFlagInfos, hsDataDtl?.pgaMetadata?.tarriffPgaDetails, allVoluntaryPGAs)}
     </Grid>
    )
  }
}

const mapStateToProps = (state, props) => ({
  // TODO: Bug: Comnponent does not register upate when dutyItems changes, adding the length fixes but this is a workaround, needs investigation
  invoiceItemIndex: props.invoiceItemIndex,
  pgaFlagInfos: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex].pgaFlagInfos || [],
  hsDataDtl: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex].merchandiseDuties[0].hsDataDtl,
  pgaRuling: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex]?.merchandiseDuties[0]?.hsDataDtl?.pgaRuling || [],
  lineItemIndex: props.lineItemIndex,
  // pgaFlags: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex].pgaFlags,
  // LaceyActFlag: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex].pgaFlags.LaceyActFlag,
  // TSCAFlag: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex].pgaFlags.TSCAFlag,
  // disclaimPgaFlag: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex].pgaFlags.disclaimPgaFlag,
  merchandiseId: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex].merchandiseId,
  fieldValidation: state.FieldValidation,
  allVoluntaryPGAs: state.DropDownValues.allVoluntaryPGAs,
  EntryTypeInfo: state.EntryTypeInfo,
  expandAll: state.FormValues.expandAll  || props.formDisabled,//
  containerListAsArray: (state.BOLInfo.container||[]).map(oneContainer=>{
    return ({...oneContainer, value: oneContainer.number, description: oneContainer.number })
  }),
})

const mapDispatchToProps = {
  ...actionCreators
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PGAItems)